var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448.659,
    height: 195.132,
    viewBox: "0 0 448.659 195.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(1052.659 -1466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-1232.451 1135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,73.175C0,32.684,32.454,0,72.659,0s72.659,32.684,72.659,73.175c0,48.783-72.659,121.958-72.659,121.958S0,121.958,0,73.175Zm72.659,48.783a48.784,48.784,0,0,0,0-97.566c-26.642,0-48.439,21.952-48.439,48.783a48.807,48.807,0,0,0,7.006,25.3l9.143-9.209a5.494,5.494,0,0,1,7.805,0l.975.984L63.125,76.174,56.3,69.3l-.975.982a4.116,4.116,0,0,1-5.854,0l-3.9-3.93a4.187,4.187,0,0,1,0-5.9L67.028,38.838a4.119,4.119,0,0,1,5.854,0l3.9,3.93a4.19,4.19,0,0,1,0,5.9l-.977.984L95.32,69.3l.975-.982a4.119,4.119,0,0,1,5.854,0l3.9,3.93a4.187,4.187,0,0,1,0,5.9L84.588,99.755a4.117,4.117,0,0,1-5.852,0l-3.9-3.93a4.19,4.19,0,0,1,0-5.9l.977-.982-6.83-6.879L55,96.146l.975.982a5.586,5.586,0,0,1,0,7.861l-9.3,9.367A48.008,48.008,0,0,0,72.659,121.958Z",
    transform: "translate(179.792 331)",
    fill: "#fb1da4"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Lawyers_NowNow",
    "data-name": "Lawyers NowNow",
    transform: "translate(-877 1544)",
    fontSize: 60,
    fontFamily: "LucidaGrande-Bold, Lucida Grande",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lawyers"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "NewPeninimMT-Bold, New Peninim MT"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 84
  }, "NowNow")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.28141e284a504a62ac3cd56ab4419734.svg";
export { ForwardRef as ReactComponent };